<template>
    <div class="reportList">
        <div class="myflex-v mb20">
            <div class="mySecTitle">测评报告</div>
        </div>
        <div v-loading="loading" class="listOutBox">
            <template v-if="certList && certList.length">
                <div class="myflex flexWrap certBoxItemBox">
                    <div class="reportListItem myflex-lv" v-for="(rItem,rIndex) in certList" :key="rIndex" @click="getReportDetail(rItem.sendId)">
                        <div class="reportListItem1 myflex-lv">
                            <div>
                                <div class="reportListItem-t ellipsis2">{{rItem.title}}</div>
                                <div class="reportListItem-major ellipsis3 inlineB">{{rItem.majorNames_show}}</div>
                                <div class="ellipsis1 reportListItem-time">{{rItem.createTime_show}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="elPageBox" v-show="total>0">
                    <el-pagination
                        background
                        :pager-count="5"
                        @current-change="currentChange"
                        :current-page.sync="pageNum"
                        :page-size="pageSize"
                        layout="prev, pager, next"
                        :total="total">
                    </el-pagination>
                </div>
            </template>
            <div v-else class="noData myflex-lv">
                <el-empty description="暂无数据" :image-size="90"></el-empty>
            </div>
        </div>
  </div>
</template>

<script>
import base from '@/api/base.js';
import checkLogin from '@/utils/checkLogin.js';
import { Form, FormItem, Input, Button, Radio, RadioGroup, Dialog, Empty } from 'element-ui';
import {
  mapState,
  mapMutations
} from 'vuex';

export default {
  name: "login",
  components: {
    [Input.name]: Input,
    [Button.name]: Button,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Dialog.name]: Dialog,
    [Empty.name]: Empty,
  },
  data() {
    return {
        loading: true,
        certList: [],
        pageNum:1,
        pageSize:12,
        total: 0,
    }
  },
  watch: {
  },
  computed: mapState(['userInfo']),
  created() {
  },
  mounted() {
      setTimeout(()=>{
          this.getReportList();
      },100)
  },
  methods: {
    ...mapMutations(['signOut']),

    //查询成绩报告
    getReportList(num) {
        var vm = this;
        if(!vm.userInfo || !vm.userInfo.token){
            return false;
        }
        vm.loading = true;
        var pageNum = num ? num : vm.pageNum;
        var data = { 
            token: vm.userInfo.token,
            pageNum:pageNum,
            pageSize: vm.pageSize,
        }
        this.$api.web.assessmentReportGetReportList(data,'errorNotTips').then(res => {
            vm.pageNum = pageNum;
            vm.total = res.body.total;
            var d = res.body.reports;
            if (res.success && d && d.length) {
                var arr = d ? d : [];
                for (var i in arr) {
                    arr[i].createTime_show =  art.formatDate(arr[i].createTime,2);
                    arr[i].majorNames_show =  arr[i].majorNames.join(',');
                }
                vm.certList = arr;
            } else {
                vm.certList = [];
            }
            vm.loading = false;
        }).catch(res=>{
            vm.loading = false;
        })
    },

    currentChange(num){
        this.getReportList(num);
    },

    //查询报告详情
    getReportDetail(sendId){
        var router = this.$router.resolve({
            path: '/certifacate',
            query: {
                sendId: sendId,
            }
        })
        window.open(router.href,'_blank')
    },

  },
};
</script>

<style lang="scss" scoped>

    .certBoxItemBox{margin:0 -12.5px;}

    .mySecTitle{font-size:18px;font-weight:600;margin:10px 0 10px 0 !important;}
    .mySecTitle::before{content:'';background: #0d88d3;}

    .elPageBox ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active{background-color: #409EFF !important;}
    .elPageBox ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active:hover{color:#fff !important;}
    .elPageBox ::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover{color: #409EFF !important;}


    .listOutBox{min-height:217px;}
    .noData{width:100%;height:100%;text-align:center;color:#999;}
    /*报告列表*/
    .reportListItem{padding:8px;text-align:center;font-size:14px;height:220px;width:169px;cursor:pointer;border:1px solid #eee;background:#fff;
    -webkit-box-shadow:0 0 12px 4px rgba(0,0,0,.05);box-shadow:0 0 12px 4px rgba(0,0,0,.05);margin: 0 12.5px 20px 12.5px;}
    .reportListItem1{padding:15px 8px;border:1px solid #eee;width: 100%;border: 1px solid #eee;height: 100%;border-radius:2px;}
    .reportListItem-t{line-height:1.5;height:54px;font-weight:600;color:$theme-color;font-size:18px;}
    .reportListItem-major{margin:10px 0 30px 0;color:#777;height:57px;font-size:14px;}
    .reportListItem-time{color:#777;}
    @media screen and(max-width:900px){
        .reportListItem{width:150px;height:200px;}
        .reportListItem-major{margin:10px 0 15px 0;}
    }
    @media screen and(max-width:600px){
    }
</style>

</style>
